export const mobile = {
  'backoffice.mobile.tabs.home': 'Ana Sayfa',
  'backoffice.mobile.tabs.accounts': 'Hesaplar',
  'backoffice.mobile.tabs.profits': 'Kârlar',
  'backoffice.mobile.tabs.commissions': 'Komisyonlar',
  'backoffice.mobile.tabs.more': 'Daha Fazla',
  'backoffice.mobile.more.myProfitHistory': 'Kâr Geçmişim',
};
